export default "<g>\n    <path d=\"M4 18a2 2 0 01-2-2V4a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2h-7l-6 4v-4H4z\"/>\n</g>\n";